import { getToken } from '@/utils/auth';
import { ElNotification } from 'element-plus';
import useNoticeStore from '@/store/modules/notice';
import emitter from '@/utils/eventBus';
import { generateUUID } from './ruoyi';

// 初始化
export const initSSE = (url: any) => {
  //正文
  url = url + '?Authorization=Bearer ' + getToken() + '&clientid=' + import.meta.env.VITE_APP_CLIENT_ID + "&uuid=" + generateUUID();
  const { data, error,eventSource } = useEventSource(url, [], {
    autoReconnect: {
      retries: 10,
      delay: 3000,
      onFailed() {
        console.log('SSE==== Failed to connect after 10 retries');
      }
    }
  });

  watch(error, () => {
    emitter.emit('sseEmiit', { code: -1, data: error.value, msg: 'error' });
    error.value = null;
  });

  watch(data, () => {
    let obj = null
    try {
      obj = JSON.parse(data.value);
    } catch {

    }
    if (!data.value) return;
    emitter.emit('sseEmiit', { code: 0, data: data.value, msg: 'success' });
    // 系统通知公告
    if (obj?.sseTopic == 'notice') {
      useNoticeStore().addNotice({
        message: obj,
        read: false,
        time: new Date().toLocaleString()
      });
      ElNotification({
        title: '消息',
        message: obj,
        type: 'success',
        duration: 3000
      });
    }
    data.value = null;
  });
  window.addEventListener('beforeunload', () => {
    eventSource.value.close();
  })
};
